import { Button, Col, Divider, Drawer, Form, Image, Input, message, Row, Skeleton, Tag } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StoreActions from 'bukku/redux/Store/actions';
import FormatNumber from 'bukku/components/Store/FormatNumber';
import QuantityInputProduct from '../QuantityInputProduct';
import { storeCommonStyles } from 'bukku/containers/Store/commonStyles';
import PriceLevelPopover from '../Popover/PriceLevelPopover';

const StyledDrawer = styled(props => <Drawer rootClassName={props.className} {...props} />)`

    ${storeCommonStyles}
    
    .header__product-name {
        margin-bottom: 1.5em;
        line-height: 1.5rem;
    }

    .col__image {
        margin-right: auto;
        margin-left: auto;

        .ant-image {
            position: relative;
            width: 100%;
            padding-top: 100%;  /* aspect ratio 1:1 */
      
            /* aspect ratio 1:1 */
            .image {
                position: absolute;
                inset: 0;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
    
            .image__placeholder {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                padding: 1.5em;
                overflow: hidden;
                font-weight: 400;
                color: var(--brand-color-teal);
                text-align: center;
                background-color: var(--primary-1);

                /* font-size: 12px; */
            }
        }
    }


    .ant-divider {
        margin: 1em 0;
    }

    .form-label {
        margin-bottom: 3px;
    }

    .icon-info-price-level {
        padding-top: 4px;
    }
`;
const {
    addItemToCart,
    addItemQty,
    toggleProductDrawer,
} = StoreActions;

/**
 * visible:
 * onClose:
 */
class StoreProductDrawer extends Component {
    formRef = React.createRef();

    componentDidUpdate(prevProps) {
        const {
            readProductDetailsState,
        } = this.props;

        // product is read
        if (readProductDetailsState === 'success' && prevProps.readProductDetailsState === 'request')
            this.onPageLoad();
    }

    onPageLoad = () => {
        const {
            shoppingCart,
            product,
        } = this.props;

        const productInCart = shoppingCart.find(item => item.productId === product.id);

        const initOrder = {
            qty: 1,
            instruction: productInCart?.instruction,
        };

        this.formRef.current.setFieldsValue(initOrder);
    };

    onDrawerClose = () => {
        const { toggleProductDrawer } = this.props; // redux
        toggleProductDrawer(false);
    };

    onSubmit = () => {
        const {
            // redux
            addItemQty,
            product,
        } = this.props;

        const formData = this.formRef.current.getFieldsValue();
        //
        addItemQty(product.id, formData.qty, formData.instruction);
        this.onDrawerClose();
        message.info(`${product.name} added to your cart.`);
    };

    renderSkeleton = () => (
        <>
            <Skeleton.Input style={{ width: 120, marginBottom: '1rem' }} active />
            <br />
            <Skeleton.Image />
            <Divider />
            <Skeleton active />
        </>
    );

    renderContent = () => {
        const {
            product,
            store,
            shoppingCart,
        } = this.props;
        const productInCart = shoppingCart.find(item => item.productId === product.id);

        return (
            <>
                <h2 className="header__product-name">{product.name}</h2>
                <Col className="col__image" span={18}>
                    <Image
                        className="image"
                        preview={!!product.pictureUrl}
                        placeholder={<div className="image__placeholder">{product.name}</div>}
                        src={product.pictureUrl}
                    />
                </Col>
                <Divider />

                <Row gutter={[12, 12]}>

                    <Col span={22}>
                        <Row>
                            <Col flex="0 0 auto">
                                <FormatNumber
                                    currency={store.currencySymbol}
                                    priceLevels={product.salePrice}
                                    suffix={`/ ${product.unitLabel}`}
                                    fontSizeLevel="large"
                                />
                            </Col>
                            <Col flex="0 0 10%" className="icon-info-price-level flex-center">
                                <PriceLevelPopover
                                    priceLevels={productInCart?.priceLevels}
                                    currentPriceLevel={productInCart?.priceLevel}
                                />

                            </Col>
                        </Row>
                    </Col>
                    <Col span={6} className="flex-center">
                        {!product.isAvailable ? <Tag color="error">Sold Out</Tag> : undefined}
                    </Col>
                    <Col span={24} className="col__description pre-wrap">
                        {product.description}
                    </Col>
                </Row>
                <Divider />

                <div className="form-label">Instructions</div>
                <Form.Item
                    name="instruction"
                    label="Instructions"
                    noStyle
                >
                    <Input.TextArea
                        placeholder="eg: Do not cut into slices!"
                        disabled={!product.isAvailable}
                    />
                </Form.Item>
            </>
        );
    };

    renderDrawerFooter = () => {
        const {
            // redux
            store,
            product,
            shoppingCart,
        } = this.props;
        const productInCart = shoppingCart.find(item => item.productId === product.id);

        return (
            <>
                {
                    productInCart?.qty ?
                        <Row gutter={[6, 6]}>
                            <Col span={24} className="flex-center">
                                <span className="flex-center">In cart:&nbsp;</span>
                                <strong>
                                    {productInCart.qty}
                                    &nbsp;
                                    x
                                    &nbsp;
                                    <FormatNumber
                                        currency={store.currencySymbol}
                                        amount={productInCart.unitPrice}
                                    />
                                </strong>
                            </Col>
                        </Row> :
                        undefined
                }
                <Row gutter={12}>
                    <Col span={11}>
                        <QuantityInputProduct formRef={this.formRef} disabled={!product.isAvailable} />
                    </Col>
                    <Col span={13}>
                        <Button
                            type="primary"
                            className="btn__add-cart"
                            onClick={this.onSubmit}
                            block
                            disabled={!product.isAvailable}
                        >
                            Add to Cart
                        </Button>
                    </Col>
                </Row>
            </>
        );
    };

    render() {
        const {
            // redux
            product,
            visible,
        } = this.props;

        return (
            <Form ref={this.formRef} layout="vertical">

                <StyledDrawer
                    // title={product?.name || ''}
                    onClose={this.onDrawerClose}
                    open={visible}
                    placement="right"
                    destroyOnClose
                    footer={this.renderDrawerFooter()}
                    width={320}
                >
                    {
                        !product.id ? this.renderSkeleton() : this.renderContent()
                    }
                </StyledDrawer>
            </Form>
        );
    }
}

export default connect(state => ({
    view: state.Store.view,
    readProductDetailsState: state.Store.readProductDetailsState,
    width: state.Store.width,
    product: state.Store.product,
    shoppingCart: state.Store.shoppingCart,
    store: state.Store.store,
    visible: state.Store.productDrawerVisible,
}), {
    addItemToCart,
    addItemQty,
    toggleProductDrawer,
})(StoreProductDrawer);
